import { Col, Button, Row, Container, Card, Form, FormGroup, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { useNavigate } from "react-router-dom";
import { SetStateAction, useEffect, useState } from "react";
import './NovoRegistro.css';
import api from "../../services/api";
import { FillBack, FillPlus } from '../../components/Icons';
import voltarIcon from '../../img/icon/Voltar.svg'
import eyeOpen from '../../img/icon/Olho.svg'
import eyeClose from '../../img/icon/Olho Fechado.svg'
import errorIcon from '../../img/icon/Error.svg'
import InputMask from 'react-input-mask';
import axios from "axios";
import { Options, Select } from "../../components/Select";
import AlertMessage from '../../components/Alert';
import ErrorIcon from '@mui/icons-material/Error';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { Tooltip } from "@mui/material";
import { Load } from "../../components/Load";
import { useSearchParams } from 'react-router-dom';
import { SupportAgent } from '@mui/icons-material';

export default function NewRegister() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const rep = searchParams.get('rep');

  const [type, setType] = useState("empresa");
  const [isLoading, setIsLoading] = useState(false);

  const [documentType, setDocumentType] = useState("cnpj");
  const [cnpj, setCnpj] = useState("");
  const [caepf, setCaepf] = useState("");
  const [cei, setCEI] = useState("");
  const [inscricaoEstadual, setInscricaoEstadual] = useState("");
  const [cnae, setCnae] = useState("");
  const [telefone, setTelefone] = useState("");
  const [cep, setCep] = useState("");
  const [endereco, setEndereco] = useState("");
  const [celular, setCelular] = useState("");
  const [site, setSite] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");
  const [estado, setEstado] = useState("");
  const [cidade, setCidade] = useState("");
  const [numero, setNumero] = useState("");
  const [razaoSocial, setRazaoSocial] = useState("");
  const [nome, setNome] = useState("");
  const [tipo, setTipo] = useState("");
  const [especialidade, setEspecialidade] = useState("");
  const [cargo, setCargo] = useState("");
  const [telefoneCel, setTelefoneCel] = useState("");
  const [responsaveis, setResponsaveis] = useState([]);
  const [responsavelSelecionado, setResponsavelSelecionado] = useState(null);
  const [idResponsavel, setResponsavelId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [fadeAlert, setFadeAlert] = useState(false);
  const [cepInvalido, setCepInvalido] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [documento, setDocumento] = useState("");
  const [password, setPassword] = useState('');
  const [passwordStrength, setPasswordStrength] = useState({ strength: '', color: '' });
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [error, setError] = useState("");

  const [respNome, setRespNome] = useState('');
  const [respTelefone, setRespTelefone] = useState('');
  const [respCargo, setRespCargo] = useState('');
  const [respEmail, setRespEmail] = useState('');

  useEffect(() => {
    const cnpjLimpo = cnpj.replace(/[\.\-\/\s]/g, '').toUpperCase();

    if (cnpjLimpo.length === 14) {
      api.get(`base-listar-empresa/${cnpjLimpo}`)
        .then(response => {
          const empresa = response.data;
          if (empresa.length > 0) {
            const emp = empresa[0];

            setRazaoSocial(emp.nome);
            setCnpj(emp.cnpj);
            setCEI(emp.cei);
            setInscricaoEstadual(emp.ie);
            setCnae(emp.cnae);
            setCep(emp.cep);
            setEndereco(emp.end);
            setNumero(emp.num);
            setComplemento(emp.comp);
            setBairro(emp.bairro);
            setEmail(emp.email)
            setEmail(emp.email)
          } else {
            console.log("Nenhuma empresa encontrada.");
          }
        })
        .catch(error => {
          console.error("Erro ao buscar empresa:", error);
        });
    }
  }, [cnpj]);

  const fetchResponsaveis = async () => {
    try {
      const response = await api.get('responsaveis');
      setResponsaveis(response.data);
    } catch (error) {
      console.error('Erro ao buscar responsáveis', error);
    }
  };

  const handleSelectResponsavel = (id: SetStateAction<null>) => {
    setResponsavelId(id);
  };

  const handleTyeChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setError('')
    setType(event.target.value);
    fetchResponsaveis();
  };

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const isInvalid = password !== confirmPassword && confirmPassword !== "";

  useEffect(() => {
    const buscarDadosCep = async () => {
      if (cep.replace(/\D/g, '').length === 8) {
        try {
          const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
          const { logradouro, bairro, localidade, uf } = response.data;

          setEndereco(prevEndereco => prevEndereco ? prevEndereco : logradouro);
          setBairro(prevBairro => prevBairro ? prevBairro : bairro);
          setEstado(prevEstado => prevEstado ? prevEstado : uf);
          setCidade(prevCidade => prevCidade ? prevCidade : localidade);
        } catch (error) {
          console.error('Erro ao buscar o CEP', error);
        }
      }
    };

    buscarDadosCep();
  }, [cep]);

  useEffect(() => {
    fetchResponsaveis();
  }, []);

  const handleCepChange = async (e: any) => {
    const cep = e.target.value.replace(/\D/g, '');
    setCep(cep);
  
    if (cep.length === 8) {
      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
  
        if (response.data.erro) {
          displayError("CEP Inválido!");
          setCepInvalido(true);
        } else {
          const { logradouro, bairro, localidade, uf } = response.data;
  
          setEndereco(logradouro || ""); 
          setBairro(bairro || "");       
          setEstado(uf || "");           
          setCidade(localidade || "");   
  
          setCepInvalido(!logradouro || !bairro || !localidade || !uf);
        }
      } catch (error) {
        console.error('Erro ao buscar o CEP', error);
        setCepInvalido(true);
      }
    } else {
      setCepInvalido(true);
    }
  };
  

  const evaluatePasswordStrength = (password: any) => {
    if (!password) return { strength: '', color: '' };

    const length = password.length;
    const hasNumbers = /\d/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (length > 8 && hasUpperCase && hasNumbers && hasSpecialChars) {
      return { strength: 'Muito forte', color: 'green' };
    } else if (length > 6 && hasUpperCase && hasNumbers) {
      return { strength: 'Forte', color: 'green' };
    } else if (length > 4 && (hasUpperCase || hasNumbers || hasSpecialChars)) {
      return { strength: 'Média', color: 'yellow' };
    } else if (length > 0) {
      return { strength: 'Fraca', color: 'red' };
    }
    return { strength: '', color: '' };
  };

  const handlePasswordChange = (e: { target: { value: any; }; }) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    const strength = evaluatePasswordStrength(newPassword);
    setPasswordStrength(strength);
  };

  const validateForm = () => {
    if (passwordStrength.strength === 'Fraca') {
      displayError("A senha é muito fraca. Por favor, escolha uma senha mais forte.");
      return false;
    }

    if (type === "parceiro" || type === "credenciado") {
      if (!name.trim()) {
        displayError("Por favor, insira seu nome.");
        return false;
      }
      if (!email.includes('@')) {
        displayError("Por favor, insira um e-mail válido.");
        return false;
      }
      if (documento.length < 11) {
        displayError("Por favor, insira um documento válido.");
        return false;
      }
      if (!password) {
        displayError("Por favor, insira uma senha.");
        return false;
      }
      if (!confirmPassword) {
        displayError("Por favor, repita a senha.");
        return false;
      }
      if (password !== confirmPassword) {
        displayError("As senhas não estão iguais.");
        return false;
      }
      if (!acceptedTerms) {
        displayError("Você deve aceitar os termos e condições.");
        return false;
      }
    } else if (type !== "responsavel") {
      if (!email.includes('@')) {
        displayError("Por favor, insira um e-mail válido.");
        return false;
      }
      if (!razaoSocial) {
        displayError("Por favor, insira uma razão social.");
        return false;
      }
      if (documentType === "cnpj" && !cnpj) {
        displayError("Por favor, insira um CNPJ.");
        return false;
      }
      if (documentType === "caepf" && !caepf) {
        displayError("Por favor, insira um CAEPF.");
        return false;
      }
      if (!cnae) {
        displayError("Por favor, insira um CNAE.");
        return false;
      }
      if (!cep) {
        displayError("Por favor, insira um CEP.");
        return false;
      }
      if (!endereco) {
        displayError("CEP Inválido!");
        return false;
      }
      if (!numero) {
        displayError("Por favor, insira um número.");
        return false;
      }
      if (!celular) {
        displayError("Por favor, insira um celular.");
        return false;
      }
      if (!password) {
        displayError("Por favor, insira uma senha.");
        return false;
      }
      if (!confirmPassword) {
        displayError("Por favor, repita a senha.");
        return false;
      }
      if (password !== confirmPassword) {
        displayError("As senhas não estão iguais.");
        return false;
      }
      if (!acceptedTerms) {
        displayError("Você deve aceitar os termos e condições.");
        return false;
      }
      if (!idResponsavel) {
        displayError("Por favor, selecione um responsável do PGR");
        return false;
      }
      if (!respNome) {
        displayError("Por favor, insira o nome do responsável.");
        return false;
      }
      if (!respCargo) {
        displayError("Por favor, insira o cargo do responsável.");
        return false;
      }
      if (!respTelefone) {
        displayError("Por favor, insira o telefone do responsável.");
        return false;
      }
      if (!respEmail) {
        displayError("Por favor, insira o email do responsável.");
        return false;
      }
    } else {
      if (!email.includes('@')) {
        displayError("Por favor, insira um e-mail válido.");
        return false;
      }
      if (!nome) {
        displayError("Por favor, insira um nome.");
        return false;
      }
      if (!tipo) {
        displayError("Por favor, insira tipo de profissional.");
        return false;
      }
      if (!documento) {
        displayError("Por favor, insira um CRM.");
        return false;
      }
      if (!especialidade) {
        displayError("Por favor, insira uma especialidade.");
        return false;
      }
      if (!cargo) {
        displayError("Por favor, insira um cargo.");
        return false;
      }
      if (!telefoneCel) {
        displayError("Por favor, insira um telefone celular.");
        return false;
      }
      if (!password) {
        displayError("Por favor, insira uma senha.");
        return false;
      }
      if (!confirmPassword) {
        displayError("Por favor, repita a senha.");
        return false;
      }
      if (password !== confirmPassword) {
        displayError("As senhas não estão iguais.");
        return false;
      }
      if (!acceptedTerms) {
        displayError("Você deve aceitar os termos e condições.");
        return false;
      }
    }
    setError("");
    return true;
  };

  const handleSubmit = async (event: { preventDefault: () => void; }) => {
    event.preventDefault();
    if (validateForm() === false) return;

    setIsLoading(true);

    let userData: any = {
      nome: name,
      email: email,
      documento: documento,
      password: password,
      chave_pix: chavePix
    };
    if (rep) {
      userData.uuid_indicacao = rep;
    }

    try {
      if (type === "parceiro") {
        await api.post('register/parceiro', userData);
      }
      // else if (type === "credenciado") {
      //   await api.post('register/credenciado', userData);
      // } 
      else if (type === "empresa") {
        let userData: any = {
          nome: name,
          email: email,
          documento: documentType === "cnpj" ? cnpj : caepf,
          password: password,
          razaoSocial: razaoSocial,
          numero: numero,
          cidade: cidade,
          estado: estado,
          bairro: bairro,
          endereco: endereco,
          cep: cep,
          complemento: complemento,
          celular: celular,
          telefone: telefone,
          cnae: cnae,
          cnpj: documentType === "cnpj" ? cnpj : null,
          caepf: documentType === "caepf" ? caepf : null,
          cei: cei,
          inscricaoEstadual: inscricaoEstadual,
          site: site,
          id_responsavel: idResponsavel,
          resp_empresa_nome: respNome,
          resp_empresa_cargo: respCargo,
          resp_empresa_telefone: respTelefone,
          resp_empresa_email: respEmail
        };
        if (rep) {
          userData.uuid_indicacao = rep;
        }
        const response = await api.post('register/empresa', userData);
        console.log(response.data)

        if (response.data.data === 'CNAE Inválido') {
          setIsLoading(false);
          displayError("CNAE inválido!");
          return;
        }

        if (response.data.data === 'CNPJ já cadastrado') {
          setIsLoading(false);
          displayError("CNPJ já cadastrado!")
          return;
        }

        if (response.data.data === 'Já existe um usuário cadastrado com o e-mail fornecido') {
          setIsLoading(false)
          displayError("E-MAIL já cadastrado!")
          return;
        }
      }

      try {
        const senha = password;
        const response = await api.post("login", { email, senha });
        const { token } = response.data;
        if (token && token.token) {
          const expirationDate = new Date(token.expires_at);
          const currentDate = new Date();
          if (expirationDate > currentDate) {
            localStorage.setItem("token", token.token);

            setIsLoading(false);

            if (type === "parceiro") {
              navigate("/empresas");
            } else if (type === "empresa") {
              navigate("/pgr");
            } else {
              navigate("/home");
            }
          } else {
            setIsLoading(false);
            setError("O token de autenticação expirou. Faça login novamente.");
          }
        } else {
          setIsLoading(false);
          setError("Credenciais inválidas. Verifique seu e-mail e senha.");
        }
      } catch (error: any) {
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          setError("E-mail ou senha incorreta.");
        } else {
          // setError("Ocorreu um erro ao fazer login. Por favor, tente novamente mais tarde.");
        }
      }
    } catch (error: any) {
      setIsLoading(false);
      if (error.response && error.response.data && error.response.data.message && error.response.data.message.includes("Duplicate entry") && error.response.data.message.includes("for key 'pgr_usuarios.pgr_usuarios_email_unique'")) {
        displayError("Já existe um usuário com o mesmo e-mail.");
      } else {
        setError("Erro ao enviar os dados. Tente novamente mais tarde.");
        console.error('Erro no registro:', error);
      }

    }
  };


  const getClassName = (fieldName: string) => {
    if (error.includes(fieldName) || (fieldName === 'senha' && error.includes('senhas'))) {
      return 'invalid';
    }
    return '';
  };

  const displayError = (message: SetStateAction<string>) => {
    setError(message);
    setShowAlert(true);
    setFadeAlert(false);

    setTimeout(() => {
      setFadeAlert(true);
      setTimeout(() => {
        setShowAlert(false);
        setError('');
      }, 500);
    }, 3500);
  };

  const [chavePix, setChavePix] = useState('');

  const handleSupportClick = () => {
    navigate('https://wa.me/5541997773357?text=Ol%C3%A1%2C+preciso+de+suporte%21');
  };

  return (
    <>
      <Load isLoading={isLoading} />
      <div>
        <div className="registerContainer">
          <div className="iconTextContainer">
            <a href="/">
              <img className="icon" src={voltarIcon} alt="Back to the login page" />
              <text className="back-text">Voltar</text>
            </a>
          </div>

          <div className="logoContainer">
            <img src="/logo.png" alt="Logo" className="img-fluid logo" />
          </div>

          <text className="access-label">Cadastre-se</text>
          <text className="descricao-text">Insira seus dados para completar seu cadastro</text>

          <form className="inside-content" onSubmit={handleSubmit}>
            <div className="form-group-register">
              <label>EU SOU</label>
              <div className="radio-container">
                <div>
                  <input
                    className="input3"
                    type="radio"
                    id="empresa"
                    name="tipo"
                    value="empresa"
                    checked={type === "empresa"}
                    onChange={handleTyeChange} />
                  <label htmlFor="empresa" className="radio-label" style={{ marginRight: '40px' }}>Empresa</label>

                  <input
                    className="input1"
                    type="radio"
                    id="parceiro"
                    name="tipo"
                    value="parceiro"
                    checked={type === "parceiro"}
                    onChange={handleTyeChange}
                  />
                  <label htmlFor="parceiro" className="radio-label" >Parceiro</label>

                  {/* <input
                    className="input2"
                    type="radio"
                    id="credenciado"
                    name="tipo"
                    value="credenciado"
                    checked={type === "credenciado"}
                    onChange={handleTyeChange} />
                  <label htmlFor="credenciado" className="radio-label">Credenciado</label> */}
                </div>
              </div>

              {type === "empresa" && (
                <>
                  <div className="input-container" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label>Selecione o Tipo de Documento</label>
                    <div className="radio-container">
                      <div>
                        <input
                          type="radio"
                          id="cnpj"
                          name="documentType"
                          value="cnpj"
                          checked={documentType === "cnpj"}
                          onChange={() => setDocumentType("cnpj")}
                        />
                        <label htmlFor="cnpj" className="radio-label">CNPJ</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="caepf"
                          name="documentType"
                          value="caepf"
                          checked={documentType === "caepf"}
                          onChange={() => setDocumentType("caepf")}
                        />
                        <label htmlFor="caepf" className="radio-label">CAEPF</label>
                      </div>
                    </div>
                  </div>

                  {documentType === "cnpj" && (
                    <div className="input-container">
                      <div className="pass-register">
                        <label>CNPJ<span style={{ color: '#DA0606' }}>*</span></label>
                        <InputMask
                          className={`pass-register ${getClassName('CNPJ')}`}
                          mask="**.***.***/****-99"
                          id='cnpj'
                          value={cnpj}
                          onChange={(e: any) => setCnpj(e.target.value.toUpperCase())}
                          placeholder="___.___.___/____-__"
                          style={{ width: '100%', textTransform: 'uppercase' }} />
                      </div>
                    </div>
                  )}

                  {documentType === "caepf" && (
                    <div className="input-container">
                      <div className="pass-register">


                        <label>
                          <Tooltip title="Cadastro de Atividade Econômica da Pessoa Física">
                            <ErrorIcon sx={{ color: '#A0A0A0', fontSize: '13px', marginRight: '5px' }} />
                          </Tooltip>
                          CAEPF
                          <span style={{ color: '#DA0606' }}>*</span>
                        </label>
                        <InputMask
                          className={`pass-register ${getClassName('CAEPF')}`}
                          mask="999.999.999/999-99"
                          id='caepf'
                          value={caepf}
                          onChange={(e: { target: { value: SetStateAction<string>; }; }) => setCaepf(e.target.value)}
                          placeholder="___.___.___/___-__"
                          style={{ width: '100%' }} />
                      </div>
                    </div>
                  )}

                  <div className="input-container">
                    <div className="pass-register">
                      <label>
                        <Tooltip title="Será utilizado para entrar no sistema">
                          <ErrorIcon sx={{ color: '#A0A0A0', fontSize: '13px', marginRight: '5px' }} />
                        </Tooltip>
                        E-MAIL
                        <span style={{ color: '#DA0606' }}>*</span>
                      </label>
                      <input
                        className={`pass-register ${getClassName('e-mail')}`}
                        type="email"
                        placeholder="Digite seu e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="pass-register">
                      <label>Razão Social<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`pass-register ${getClassName('razão social')}`}
                        type="text"
                        placeholder="Digite sua razão social"
                        value={razaoSocial}
                        onChange={(e) => setRazaoSocial(e.target.value)} />
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="pass-register">
                      <label>Inscrição Estadual</label>
                      <InputMask
                        className={`pass-register`}
                        mask="99999-999"
                        type="text"
                        id="inscricaoEstadual"
                        placeholder="Digite a Incrição Estadual"
                        value={inscricaoEstadual}
                        onChange={(e: { target: { value: SetStateAction<string>; }; }) => setInscricaoEstadual(e.target.value)}
                        style={{ width: '100%' }} />
                    </div>
                    <div className="pass-register">
                      <label>
                        <Tooltip title="Classificação Nacional de Atividades Econômicas Para consultar o seu, entre no link: https://cnae.ibge.gov.br/">
                          <ErrorIcon sx={{ color: '#A0A0A0', fontSize: '13px', marginRight: '5px' }} />
                        </Tooltip>
                        CNAE
                        <span style={{ color: '#DA0606' }}>*</span>
                      </label>
                      <InputMask
                        mask="9999-9/99"
                        value={cnae}
                        onChange={(e: { target: { value: SetStateAction<string>; }; }) => setCnae(e.target.value)}
                        placeholder="Digite o CNAE"
                        className="form-control"
                        style={{ width: '100%' }} />
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="pass-register">
                      <label>CEP<span style={{ color: '#DA0606' }}>*</span></label>
                      <InputMask
                        className={`pass-register ${getClassName('CEP')}`}
                        mask="99999-999"
                        type="text"
                        id="cep"
                        placeholder="_____-___"
                        value={cep}
                        onChange={handleCepChange}
                        style={{ width: '100%' }} />
                    </div>

                    <div className="pass-register">
                      <label>Endereço</label>
                      <input
                        className={`pass-register ${getClassName('endereço')}`}
                        type="text"
                        placeholder="Digite seu endereço"
                        value={endereco}
                        onChange={(e) => setEndereco(e.target.value)}
                        disabled={!cepInvalido} />
                    </div>

                    <div className="pass-register">
                      <label>Número<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`pass-register ${getClassName('número')}`}
                        type="text"
                        placeholder="Digite seu número"
                        value={numero}
                        onChange={(e) => setNumero(e.target.value)} />
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="pass-register">
                      <label>Complemento</label>
                      <input
                        className={`pass-register ${getClassName('complemento')}`}
                        type="text"
                        placeholder="Digite seu complemento"
                        value={complemento}
                        onChange={(e) => setComplemento(e.target.value)}  />
                    </div>

                    <div className="pass-register">
                      <label>Estado</label>
                      <input
                        className={`pass-register ${getClassName('estado')}`}
                        type="text"
                        placeholder="Digite seu estado"
                        value={estado}
                        onChange={(e) => setEstado(e.target.value)}
                        disabled={!cepInvalido} />
                    </div>

                    <div className="pass-register">
                      <label>Cidade</label>
                      <input
                        className={`pass-register ${getClassName('cidade')}`}
                        type="text"
                        placeholder="Digite sua cidade"
                        value={cidade}
                        onChange={(e) => setCidade(e.target.value)}
                        disabled={!cepInvalido} />
                    </div>

                    <div className="pass-register">
                      <label>Bairro</label>
                      <input
                        className={`pass-register ${getClassName('bairro')}`}
                        type="text"
                        placeholder="Digite sua bairro"
                        value={bairro}
                        onChange={(e) => setBairro(e.target.value)}
                        disabled={!cepInvalido} />
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="pass-register">
                      <label>Telefone Fixo</label>
                      <InputMask
                        className={`pass-register ${getClassName('telefone')}`}
                        mask="(99) 9999-9999"
                        value={telefone}
                        onChange={(e: { target: { value: SetStateAction<string>; }; }) => setTelefone(e.target.value)}
                        placeholder="(__) ____-____"
                        style={{ width: '100%' }} />
                    </div>

                    <div className="pass-register">
                      <label>Celular<span style={{ color: '#DA0606' }}>*</span></label>
                      <InputMask
                        mask="(99) 99999-9999"
                        value={celular}
                        onChange={(e: { target: { value: SetStateAction<string>; }; }) => setCelular(e.target.value)}
                        placeholder="(__) _____-____"
                        style={{ width: '100%' }}
                        className={`pass-register ${getClassName('celular')}`} />
                    </div>

                    <div className="pass-register">
                      <label>Site</label>
                      <input
                        className={`pass-register ${getClassName('site')}`}
                        type="text"
                        placeholder="Digite o endereço do seu site"
                        value={site}
                        onChange={(e) => setSite(e.target.value)} />
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="pass-register password-input-container">
                      <label>SENHA<span style={{ color: '#DA0606' }}>*</span></label>
                      <div style={{ position: 'relative' }}>
                        <input
                          className={`form-control password-input ${passwordStrength.color}`}
                          type={showPassword ? "text" : "password"}
                          placeholder="Digite sua senha"
                          value={password}
                          onChange={handlePasswordChange}
                        />
                        <img
                          className="olho"
                          src={showPassword ? eyeClose : eyeOpen}
                          onClick={togglePasswordVisibility}
                          alt="Toggle password visibility"
                        />
                      </div>
                      <span className={`badges ${passwordStrength.color}`}>{passwordStrength.strength}</span>
                    </div>


                    <div className="pass-register">
                      <label>REPITA SUA SENHA<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`form-control ${password && confirmPassword && password === confirmPassword ? 'is-valid' : confirmPassword && 'is-invalid'}`}
                        type={showPassword ? "text" : "password"}
                        placeholder="Repita sua senha"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                    <div className="pass-register">
                      <label>
                        <Tooltip title="Responsável por assinar e revisar o PGR">
                          <ErrorIcon sx={{ color: '#A0A0A0', fontSize: '13px', marginRight: '5px' }} />
                        </Tooltip>
                        RESPONSÁVEL - PGR
                        <span style={{ color: '#DA0606' }}>*</span>
                      </label>
                      <FormGroup>
                        <Select id="selectResponsavel" onSelect={handleSelectResponsavel}>
                          {responsaveis.map((responsaveis: any) => (
                            <Options
                              key={responsaveis.id}
                              value={responsaveis.id}
                              name={responsaveis.nome}
                              selected={responsaveis.id == responsavelSelecionado} />
                          ))}
                        </Select>
                      </FormGroup>
                      <span style={{ color: '#A0A0A0', fontSize: '10px', marginLeft: '5px', marginTop: '5px' }}>
                        <AnnouncementIcon sx={{ color: '#A0A0A0', fontSize: '13px', marginRight: '5px' }} />
                        Caso o responsável não esteja listado aqui, solicite ao suporte a inclusão dele!
                      </span>
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="pass-register">
                      <label>
                        <Tooltip title="Responsável Geral da Empresa">
                          <ErrorIcon sx={{ color: '#A0A0A0', fontSize: '13px', marginRight: '5px' }} />
                        </Tooltip>
                        Responsável Geral
                        <span style={{ color: '#DA0606' }}>*</span>
                      </label>
                      <input
                        className={`pass-register ${getClassName('nomeResponsavel')}`}
                        type="text"
                        placeholder="Digite o Responsável pela Empresa"
                        value={respNome}
                        onChange={(e) => setRespNome(e.target.value)} />
                    </div>
                    <div className="pass-register">
                      <label>Cargo do Responsável Geral<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`pass-register ${getClassName('cargoResponsavel')}`}
                        type="text"
                        placeholder="Digite o Cargo do Responsável"
                        value={respCargo}
                        onChange={(e) => setRespCargo(e.target.value)} />
                    </div>
                    <div className="pass-register">
                      <label>Telefone do Responsável Geral<span style={{ color: '#DA0606' }}>*</span></label>
                      <InputMask
                        mask="(99) 99999-9999"
                        value={respTelefone}
                        onChange={(e: { target: { value: SetStateAction<string>; }; }) => setRespTelefone(e.target.value)}
                        placeholder="(__) _____-____"
                        style={{ width: '100%' }}
                        className={`pass-register ${getClassName('telefoneResponsavel')}`} />
                    </div>
                    <div className="pass-register">
                      <label>Email do Responsável Geral<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`pass-register ${getClassName('emailResponsavel')}`}
                        type="text"
                        placeholder="Digite o Email do Responsável"
                        value={respEmail}
                        onChange={(e) => setRespEmail(e.target.value)} />
                    </div>
                  </div>
                </>
              )}
              {(type === "parceiro" || type === "credenciado") && (
                <>
                  <div className="input-container">
                    <div className="pass-register">
                      <label>NOME<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`pass-register ${getClassName('nome')}`}
                        type="text"
                        placeholder="Digite seu nome"
                        value={name}
                        onChange={(e) => setName(e.target.value)} />
                    </div>

                    <div className="pass-register">
                      <label>E-MAIL<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`pass-register ${getClassName('e-mail')}`}
                        type="email"
                        placeholder="Digite seu e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} />
                    </div>

                    {type === "credenciado" && (
                      <div className="pass-register">
                        <label>Chave PIX<span style={{ color: '#DA0606' }}>*</span></label>
                        <input
                          className={`pass-register ${getClassName('chave-pix')}`}
                          type="text"
                          placeholder="Digite sua chave PIX"
                          value={chavePix}
                          onChange={(e) => setChavePix(e.target.value)} />
                      </div>
                    )}

                    <div className="pass-register">
                      <label>CNPJ ou CPF<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`pass-register ${getClassName('documento')}`}
                        type="text"
                        placeholder="Digite seu CNPJ ou CPF"
                        value={documento}
                        onChange={(e) => setDocumento(e.target.value)} />
                    </div>
                  </div>
                  <div className="input-container">
                    <div className="pass-register password-input-container">
                      <label>SENHA<span style={{ color: '#DA0606' }}>*</span></label>
                      <div style={{ position: 'relative' }}>
                        <input
                          className={`form-control password-input ${passwordStrength.color}`}
                          type={showPassword ? "text" : "password"}
                          placeholder="Digite sua senha"
                          value={password}
                          onChange={handlePasswordChange}
                        />
                        <img
                          className="olho"
                          src={showPassword ? eyeClose : eyeOpen}
                          onClick={togglePasswordVisibility}
                          alt="Toggle password visibility"
                        />
                      </div>
                      <span className={`badges ${passwordStrength.color}`}>{passwordStrength.strength}</span>
                    </div>

                    <div className="pass-register">
                      <label>REPITA SUA SENHA<span style={{ color: '#DA0606' }}>*</span></label>
                      <input
                        className={`form-control ${password && confirmPassword && password === confirmPassword ? 'is-valid' : confirmPassword && 'is-invalid'}`}
                        type={showPassword ? "text" : "password"}
                        placeholder="Repita sua senha"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="input-container">
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id="agree"
                    name="agree"
                    checked={acceptedTerms}
                    onChange={(e) => setAcceptedTerms(e.target.checked)} />
                  <label htmlFor="agree" className="checkbox-label">
                    Eu concordo com os <a href="#">Termos & Condições</a> e a <a href="#">Política de Privacidade</a>.
                  </label>
                </div>
              </div>

              <div className="button-cadastrar btn-content">
                <button className="btn-access">Cadastrar</button>
              </div>
            </div>
          </form>
        </div>
        {showAlert && (
          <div className={`alert-container ${fadeAlert ? 'fade-out' : ''}`}>
            <Alert variant="danger" onClose={() => { setShowAlert(false); setError(''); }} dismissible>
              {error}
            </Alert>
          </div>
        )}
        <a href="https://wa.me/5541997773357?text=Ol%C3%A1%2C+preciso+de+suporte%21">
          <div className="support-ball">
            <SupportAgent />
          </div>
        </a>

      </div>
    </>
  );
}
